export default {
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    cancel: 'Cancelar',

    'basic-data': 'Datos principales',
    'material-name': 'Nombre de material',
    'main-material': 'Material principal',
    'account-no-is-automatic-or-manual': 'Número de cuenta (automático o manual)',
    
    'material-type': {
        title: 'Tipo de material',
        main: 'Principal',
        sub: 'Sub',
    },

    'material-category':{
        title: 'Clasificación de artículos',
        'commercial-ordinary-material': 'Producto',
        'raw-material': 'Materia prima',
        'indirect-raw-material': 'Materia prima indirecta',
        'material-under-manufacture': 'Material en fabricacion',
        'manufactured-material': 'Material terminado',
    },

    'unit-size': 'Unidad',
    'additional-data': 'Datos adicionales',

    'min': 'Mínimo',
    'max': 'Máximo',
    manufacturer: 'Fabricante',
    specifications: 'Especificaciones/fuente',

    'material-movement-data': 'Datos de movimiento de material',
    
    'purchasing-price': 'Precio de compra',
    'selling-price': 'Precio de venda',
    'purchase-account': 'Cuenta de compras',
    'sales-account': 'Cuenta de ventas',
    notes: 'Notas',
    
    'delete-the-material': 'Eliminar arrtículo',
    'are-you-sure-you-want-to-delete-the-material-$': '¿Estas Seguro de Eliminar Artículo: {materialName}?',
    
    'edit-material': 'Editar artículo',
    'create-material': 'Crear artículo',
    'confirm-disengagement-of-material': 'Confirmar la desconexión del material.',
    'are-you-sure-you-want-to-disconnect?': '¿Estás segura de que quieres desconectar?'
}